import { useContext, useState } from "react";
import { MdClose, MdKeyboardArrowDown } from "react-icons/md";
import { AppContext } from "../App";
import logo from "../assets/logo.png";
import { snjContact } from "../ones/Footer";
import Backdrop from "./Backdrop";

const primaryLinks = [
  { label: "Services", item: "services" },
  { label: "Projects", item: "projects" },
  { label: "Contacts", item: "contact_us" },
];

const aboutLinks = [
  { label: "Overview", item: "about_us", subItem: "overview" },
  { label: "Team", item: "about_us", subItem: "team" },
  { label: "Legal", item: "about_us", subItem: "policies" },
];

export default function SideBar() {
  const appContext = useContext(AppContext);
  const [showAbout, setShowAbout] = useState(false);

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function goTo(item) {
    appContext.navTo({ item });
    closeSideBar();
  }

  function goToAbout(subItem) {
    appContext.navTo({ item: "about_us", subItem });
    closeSideBar();
  }

  function goToServicesHome() {
    appContext.navTo({ item: "services" });
    closeSideBar();
  }

  return (
    <>
      <Backdrop
        style={{
          visibility: appContext.isSideBarOpen ? "visible" : "hidden",
          opacity: appContext.isSideBarOpen ? "1" : "0",
          zIndex: "9998",
          pointerEvents: appContext.isSideBarOpen ? "auto" : "none",
        }}
      />

      <aside className="SideBar" data-open={appContext.isSideBarOpen}>
        <div className="body mNoScrollBar">
          <div className="vex-mobile-shell">
            <div className="vex-mobile-topbar">
              <button
                type="button"
                className="tgm-orion-mobile-brand"
                onClick={() => goTo("home")}
              >
                <img src={logo} alt="SNJ Tanzania Limited logo" />
              </button>

              <button
                type="button"
                className="tgm-mobile-close"
                onClick={closeSideBar}
                aria-label="Close navigation menu"
              >
                <MdClose />
              </button>
            </div>

            <div className="vex-mobile-links">
              <button
                type="button"
                className="tgm-orion-mobile-link"
                onClick={() => goTo("home")}
              >
                <strong>Home</strong>
              </button>

              <div className="vex-mobile-services-block">
                <button
                  type="button"
                  className="tgm-orion-mobile-link tgm-orion-mobile-link-services"
                  onClick={() => setShowAbout((prev) => !prev)}
                >
                  <strong>About</strong>
                  <MdKeyboardArrowDown
                    className="tgm-orion-mobile-services-caret"
                    data-open={showAbout}
                  />
                </button>

                <div
                  className="tgm-orion-mobile-service-grid"
                  data-open={showAbout}
                >
                  {aboutLinks.map((link) => (
                    <button
                      key={link.subItem}
                      type="button"
                      className="tgm-orion-mobile-service-section-title"
                      onClick={() => goToAbout(link.subItem)}
                    >
                      {link.label}
                    </button>
                  ))}
                </div>
              </div>

              {primaryLinks.map((link) => (
                <button
                  key={link.item}
                  type="button"
                  className="tgm-orion-mobile-link"
                  onClick={() =>
                    link.item === "services" ? goToServicesHome() : goTo(link.item)
                  }
                >
                  <strong>{link.label}</strong>
                </button>
              ))}

              {/* <div className="vex-mobile-services-block">
                <button
                  type="button"
                  className="tgm-orion-mobile-link tgm-orion-mobile-link-services"
                  onClick={() => setShowServices((prev) => !prev)}
                >
                  <strong>Service Categories</strong>
                  <MdKeyboardArrowDown
                    className="tgm-orion-mobile-services-caret"
                    data-open={showServices}
                  />
                </button>

                <div
                  className="tgm-orion-mobile-service-grid"
                  data-open={showServices}
                >
                  {serviceMenuGroups.map((group) => (
                    <button
                      key={group.slug}
                      type="button"
                      className="tgm-orion-mobile-service-section-title"
                      onClick={() => goToService(group.slug)}
                    >
                      {group.title}
                    </button>
                  ))}
                </div>
              </div> */}
            </div>

            <div className="tgm-orion-mobile-contact">
              <a href={`tel:${snjContact.phone.replace(/\s/g, "")}`}>{snjContact.phone}</a>
              <a href={`mailto:${snjContact.email}`}>{snjContact.email}</a>
              <p>
                Civil and building works, project management, and specialized
                construction delivery.
              </p>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
}
